import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../../components/ui/card";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import Table2 from "../../../components/table/table-2";
import { EyeOff, Eye, Ambulance, LifeBuoy, UserPlus } from "lucide-react";
import { useState } from "react";
import FormRenderer from "../../../components/input-field/form-renderer";
import { createEmployeeFields } from "../../../config/role/create-employee";
import { isFormValid } from "../../../utils/validators";
import { columns, data } from "../../../data/admin/role/create-employee";
import { createEmployeeSignup } from "../../../services/employee/employee-auth-service";
import { useGetAllRoles } from "../../../hook/admin/use-role";
import { useGetAllBranches } from "../../../hook/admin/use-branch";
import { useGetAllEmployee } from "../../../hook/employee/use-employee-details";
import Loader from "../../../components/loader/loader";
import {
  showSuccessToast,
  showErrorToast,
  showWarningToast,
  showInfoToast,
} from "../../../utils/toast-utils";
import {
  changeEmployeeStatus,
  getAllEmployee,
  getEmployeeById,
} from "../../../services/employee/employee-details-service";
import ViewEmployeeDataByID from "../../../components/viewsModals/ViewEmployeeDataById";
import { useQuery } from "@tanstack/react-query";

const CreateEmployee = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConformPassword, setShowConformPassword] = useState(false);
  const [showpin, setShowPin] = useState(false);
  const [form, setForm] = useState({});
  const [pin, setPin] = useState("");
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);
  const [isViewLoading, setIsViewLoading] = useState(false);

  const { data: roles = [], isLoading: rolesLoading } = useGetAllRoles();
  const { data: branches = [], isLoading: branchLoading } = useGetAllBranches();
  const [singleEmployeeData, setSingleEmployeeData] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const employeeColumns = [
    {
      key: "index",
      label: "S.No",
      render: (_, index) => index + 1,
    },
    {
      key: "employeeId",
      label: "Employee ID",
    },
    {
      key: "name",
      label: "Name",
      render: (row) => `${row.title} ${row.name}`,
    },
    {
      key: "role",
      label: "Role",
    },
    {
      key: "mobile",
      label: "Mobile",
    },
    {
      key: "email",
      label: "Email",
    },
    {
      key: "isActive",
      label: "Status",
      render: (row) => (
        <button
          onClick={() => handleStatus(row)}
          className={` rounded-full border border-blue-700 h-[28px] w-[50px] text-xs font-semibold items-center flex justify-start`}
        >
          <span className=" inline-block bg-blue-700 h-[22px] w-[22px] rounded-full"></span>
        </button>
      ),
    },

    {
      key: "action",
      label: "Action",

      render: (row) => (
        <div className="flex gap-2">
          <button
            className="px-2 py-1 text-xs bg-blue-100 text-blue-600 rounded hover:bg-blue-200"
            onClick={() => handleViewEmployee(row?.id)}
          >
            View
          </button>
        </div>
      ),
    },
  ];

  const handleStatus = async (row) => {
    setIsEmployeeLoading(true);
    try {
      const res = await changeEmployeeStatus({
        id: row.id,
        isActive: !row.isActive,
      });
      if (res?.status === 200) {
        showSuccessToast(
          res?.data?.message ||
            res?.data?.data?.message ||
            "status updated successfully",
        );
      } else {
        showErrorToast(
          res?.data?.message ||
            res?.data?.data?.message ||
            "Something went wrong",
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsEmployeeLoading(false);
    }
  };

  const handleViewEmployee = async (id) => {
    try {
      if (!id) return;

      setIsViewLoading(true);

      const res = await getEmployeeById({ id });

      const apiData = res?.data?.data;

      setSingleEmployeeData(apiData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsViewLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      if (form.password !== form.confirm_password) {
        showWarningToast("Passwords do not match");
        return;
      }

      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

      if (!passwordRegex.test(form.password)) {
        showWarningToast(
          "Password must contain 8+ characters, uppercase, lowercase, number and special character.",
        );
        return;
      }
      setIsEmployeeLoading(true);

      const { confirm_password, ...payload } = form;
      const response = await createEmployeeSignup(payload);
      console.log("employee response", response);

      if (response?.status === 201 || response?.status === 200) {
        showSuccessToast("Employee Created Successfully");
        setForm({});
        setPin("");
      } else {
        showErrorToast(response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      showErrorToast(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsEmployeeLoading(false);
    }
  };

  const { data: employee, isLoading: employeeLoading } = useQuery({
    queryKey: ["get-all-employee", currentPage, limit],
    queryFn: async () => {
      return await getAllEmployee({ limit, page: currentPage });
    },
  });

  const employeeList = employee?.data?.data?.rows || [];

  return (
    <div className="md:p-2">
      {(isEmployeeLoading || isViewLoading) && <Loader />}
      <h2 className="text-xl pl-4 flex items-center justify-start gap-2 md:text-2xl text-black font-bold mb-4 md:mb-8">
        <UserPlus className="text-purple-700" />
        Create Employee
      </h2>
      <div className="grid grid-cols-1 gap-8">
        <Card className=" rounded-xl bg-white  border-none ">
          <div className="flex flex-col p-2 md:p-6">
            <div className="w-full">
              <FormRenderer
                fields={createEmployeeFields}
                values={form}
                setValues={setForm}
              />
              <div className="w-full grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-2 mt-4">
                {/* Role */}
                <div className="flex flex-col gap-2">
                  <label className="font-semibold text-gray-700">Roles</label>
                  <select
                    className="border rounded-md p-2 w-full"
                    value={form.role || ""}
                    onChange={(e) => setForm({ ...form, role: e.target.value })}
                  >
                    <option disabled value="">
                      Select Role
                    </option>
                    {rolesLoading && <option>Loading...</option>}
                    {!rolesLoading &&
                      roles.map((role) => (
                        <option key={role?.id} value={role?.roleName}>
                          {role?.roleName}
                        </option>
                      ))}
                  </select>
                </div>

                {/* Branch */}
                <div className="flex flex-col sm:col-span-1 gap-2">
                  <label className="font-semibold text-gray-700">
                    Hospital Branch
                  </label>
                  <select
                    className="border rounded-md p-2 w-full"
                    value={form.hospital_branch_id || ""}
                    onChange={(e) =>
                      setForm({ ...form, hospital_branch_id: e.target.value })
                    }
                  >
                    <option disabled value="">
                      Select Branch
                    </option>
                    {branchLoading && <option>Loading...</option>}
                    {!branchLoading &&
                      branches?.map((branch) => (
                        <option key={branch?.id} value={branch?.id}>
                          {branch?.hospitalName}
                        </option>
                      ))}
                  </select>
                </div>

                {/* Password */}
                <div className="flex flex-col col-span-2 sm:col-span-1 gap-2 relative">
                  <label className="font-semibold text-gray-700">
                    Password
                  </label>
                  <div className="relative">
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={form.password || ""}
                      onChange={(e) =>
                        setForm({ ...form, password: e.target.value })
                      }
                    />
                    <Button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      variant="admin.default"
                      className="absolute -right-1  top-1/2 -translate-y-1/2 px-2"
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </Button>
                  </div>
                </div>

                {/* Confirm Password */}
                <div className="flex flex-col col-span-2 sm:col-span-1 gap-2 relative">
                  <label className="font-semibold text-gray-700">
                    Confirm Password
                  </label>
                  <div className="relative">
                    <Input
                      type={showConformPassword ? "text" : "password"}
                      placeholder="Confirm Password"
                      value={form.confirm_password || ""}
                      onChange={(e) =>
                        setForm({ ...form, confirm_password: e.target.value })
                      }
                    />
                    <Button
                      type="button"
                      onClick={() =>
                        setShowConformPassword(!showConformPassword)
                      }
                      variant="admin.default"
                      className="absolute -right-1  top-1/2 -translate-y-1/2 px-2"
                    >
                      {showConformPassword ? (
                        <EyeOff size={18} />
                      ) : (
                        <Eye size={18} />
                      )}
                    </Button>
                  </div>
                </div>

                {/* Security PIN */}
                <div className="flex col-span-2 sm:col-span-1 flex-col gap-2 relative">
                  <label className="font-semibold text-gray-700">
                    Security PIN
                  </label>
                  <div className="relative">
                    <Input
                      type={showpin ? "text" : "password"}
                      placeholder="Security PIN"
                      value={pin}
                      onChange={(e) => setPin(e.target.value)}
                    />
                    <Button
                      type="button"
                      onClick={() => setShowPin(!showpin)}
                      variant="admin.default"
                      className="absolute -right-1  top-1/2 -translate-y-1/2 px-2"
                    >
                      {showpin ? <EyeOff size={18} /> : <Eye size={18} />}
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 mt-3">
              <Button
                variant="admin.secondary"
                disabled={
                  !isFormValid(createEmployeeFields, form) ||
                  !form.password ||
                  !form.confirm_password ||
                  !form.role ||
                  !form.hospital_branch_id
                }
                onClick={handleSubmit}
              >
                {isEmployeeLoading && (
                  <Loader className="animate-spin h-4 w-4" />
                )}

                {isEmployeeLoading ? "Creating..." : "Submit"}
              </Button>
            </div>
          </div>
        </Card>

        <Card className="rounded-xl border-none bg-white ">
          <div className="flex px-4 md:px-8 items-center w-full justify-between">
            <CardTitle className="text-md md:text-xl text-gray-600">
              All Employees
            </CardTitle>
            <div className="flex flex-col pt-2 gap-1">
              <label className="font-semibold" htmlFor="limit">
                Select Limit
              </label>
              <select
                onChange={(e) => setLimit(e.target.value)}
                className="w-[150px] p-2 border bg-gradient-to-r from-blue-600 to-purple-700 text-white font-semibold rounded-lg"
                name=""
                id="limit"
              >
                <option className="bg-purple-800 text-white" value="5">
                  5
                </option>
                <option className="bg-purple-800 text-white" value="10">
                  10
                </option>
                <option className="bg-purple-800 text-white" value="20">
                  20
                </option>
                <option className="bg-purple-800 text-white" value="50">
                  50
                </option>
                <option className="bg-purple-800 text-white" value="100">
                  100
                </option>
              </select>
            </div>
          </div>
          <CardContent className="pl-4 text-[#081a3a] font-bold">
            {employeeLoading ? (
              <div className="flex justify-center py-10">
                <Loader />
              </div>
            ) : (
              <>
                <Table2
                  columns={employeeColumns}
                  data={employeeList}
                  rowsPerPage={4}
                />

                <div className="w-full flex justify-center items-center py-4 gap-4">
                  <Button
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    disabled={currentPage === 1}
                    variant="admin.secondary"
                  >
                    prev
                  </Button>

                  <div>
                    Page {employee?.data?.data?.currentPage} of{" "}
                    {employee?.data?.data?.totalPages}
                  </div>

                  <Button
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={employee?.data?.data?.totalPages === currentPage}
                    variant="admin.secondary"
                  >
                    next
                  </Button>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>

      {singleEmployeeData && (
        <ViewEmployeeDataByID
          viewEmployeeData={singleEmployeeData}
          setViewEmployeeData={setSingleEmployeeData}
        />
      )}
    </div>
  );
};

export default CreateEmployee;
